import { render, staticRenderFns } from "./bnvdate.vue?vue&type=template&id=9b876622&"
import script from "./bnvdate.vue?vue&type=script&lang=js&"
export * from "./bnvdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports